import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=7524ca56&scoped=true&"
import script from "./MyService.vue?vue&type=script&lang=js&"
export * from "./MyService.vue?vue&type=script&lang=js&"
import style0 from "./MyService.vue?vue&type=style&index=0&id=7524ca56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524ca56",
  null
  
)

export default component.exports